export default class BaseService {
}